module.exports = __webpack_public_path__ + "static/media/res1.efd83a97.PNG";